import React from "react";
export function OrderAddress({ label, address, recipient }) {
    return (React.createElement("div", { className: "p-4" },
        React.createElement("div", { className: "flex flex-col gap-2 text-sm py-2" },
            React.createElement("div", { className: "text-lg font-semibold py-2" }, label),
            React.createElement("div", { className: "font-semibold" }, recipient?.full_name),
            React.createElement("div", { className: "text-dark-gray" }, address?.full_address),
            React.createElement("div", { className: "flex gap-2" },
                React.createElement("div", { className: "font-semibold" }, "Phone Number:"),
                React.createElement("div", { className: "text-dark-gray" }, recipient?.phone_number)),
            React.createElement("div", { className: "flex gap-2" },
                React.createElement("div", { className: "font-semibold" }, "Email:"),
                React.createElement("div", { className: "text-dark-gray" }, recipient?.email)))));
}
